import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { twJoin } from 'tailwind-merge';
import { useActiveSigner } from '../../hooks/useActiveSigner';
import { isExpired } from '../../lib/signer';
import { Loader } from '../Loader';

export type OneClickState = 'active' | 'activeOnAnotherDevice' | 'inactive';

export const OneClickStateBadge = () => {
  const { data: activeSigner, isLoading } = useActiveSigner();
  const expired = isExpired(activeSigner);

  return isLoading ? (
    <Loader className="size-4" />
  ) : (
    <span
      className={twJoin(
        'flex items-center gap-1 rounded bg-backgroundHoverOverlay p-1 pr-[6px] text-xs',
        activeSigner ? 'text-contentPrimary' : 'text-contentSecondary'
      )}
    >
      {expired || !activeSigner ? (
        <>
          <XMarkIcon className="size-4" /> {expired ? 'Expired' : 'OFF'}
        </>
      ) : (
        <>
          <CheckIcon className="size-4" /> ON
        </>
      )}
    </span>
  );
};
